<script>
  import FlightEventHandler from './FlightEventHandler.svelte';
	import OwnshipMarker from './ownshipMarker'
</script>

<FlightEventHandler handlerClass={OwnshipMarker} />